import React, { useEffect, useCallback } from 'react';
import Modal from '@mui/material/Modal';
import { AxlModalBox } from '../AxlBox';

const modalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function AxlModal({ trigger, isOpen = false, disabled, onClose = () => {/* empty */}, onRendered = () => {/* empty */}, isClose = false, ...props }) {
  const [open, setOpen] = React.useState(isOpen);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    onClose();
  }, [onClose]);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (isClose) {
      handleClose();
    }
  }, [isClose, handleClose]);

  return (
    <>
      {trigger && React.cloneElement(trigger, {
        onClick: (event) => {
          if (!disabled) {
            handleOpen();
            onRendered();
            trigger?.props?.onClick?.(event);
          } else {
            event.preventDefault();
            event.stopPropagation();
          }
        },
      })}
      <Modal
        sx={modalStyle}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <AxlModalBox onClose={handleClose} bgcolor={props.bgcolor} {...props}>
          {props.children}
        </AxlModalBox>
      </Modal>
    </>
  );
}
